import { useEffect, useRef } from 'react'

export const useRootClassSync = classes => {
  const prevRef = useRef([])

  useEffect(() => {
    const root = document.documentElement
    const prev = prevRef.current

    for (const c of prev) if (c) root.classList.remove(c)

    const uniq = Array.from(new Set(classes.filter(Boolean)))
    for (const c of uniq) root.classList.add(c)

    prevRef.current = uniq

    return () => {
      for (const c of uniq) root.classList.remove(c)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classes.join(' ')])
}
